<template>
	<div class="videosCourse ">


		<el-input v-model="key" class="h-[58px] text-[16px] mb-[10px]" @change="change"
			:placeholder="langInfo.study_keywords_search"></el-input>
		<div class="" v-if="isFinish&&subjectList.length>0">
			<div style="min-height: 500px;">
				<div :class="item.is_expired==1?'bg-[#e7e9eb]':'bg-white'" v-for="(item,index) in subjectList"
					:key="index" class="no-underline py-[20px] px-[16px] box-border   mb-[12px] ">
					<div class="rounded-[5px]   flex items-center justify-between">
						<div class="flex-1 flex">
							<el-image @click="showClick(item,index)"
								class="w-[180px] h-[120px] cursor-pointer mr-[14px] rounded-[6px]"
								:src="item.courseSubject.image" fit="cover"></el-image>
							<div class="flex-1 mr-[10px]">
								<div class="text-[16px] text-[#000000]  mb-[10px] flex items-center justify-between">
									<div class="yw-text-cut-1 flex-1">
										{{item.courseSubject.name}}
									</div>
									<div @click="subjectInfoClick(item,index)"
										class="w-[200px] cursor-pointer text-right text-[#2979FF] text-[12px] ml-[20px]">
										{{langInfo.study_subject_view}}>>
									</div>
								</div>
								<div class="flex items-center mb-[8px] text-[12px]">
									<div class="flex items-center min-w-[90px] mr-[10px]">
										<img src="@/static/image/icon25.png" class="w-[15px] h-[15px] mr-[10px]" />
										<div class="flex-1  text-[#A2A2A2]">
											{{langInfo.study_subject_title}}
										</div>
									</div>
									<div class="flex-1  text-[#0F1419]">
										{{langInfo.study_total}}{{item.course_chapter_small_count}}{{langInfo.study_chapter}};
										{{item.video_count}}{{langInfo.study_total_video}}
										| {{item.doc_count}}{{langInfo.study_course_video}}
									</div>
								</div>
								<div class="flex items-center mb-[8px] text-[12px]">
									<div class="flex items-center min-w-[90px] mr-[10px]">
										<img src="@/static/image/icon34.png" class="w-[15px] h-[15px] mr-[10px]" />
										<div class="  text-[#A2A2A2]">
											{{langInfo.study_teacher_title}}
										</div>
									</div>
									<div class="flex-1  text-[#0F1419]">

										<label v-if="item.teacher_info">{{item.teacher_info.name}}</label>

										<label class=" text-[#2979FF] ml-[20px] cursor-pointer"
											@click="teacherInfoClick(item,index)">{{langInfo.study_teacher_view}}>></label>
									</div>
								</div>
								<div class="flex items-center mb-[10px] text-[12px]">
									<div class="flex items-center min-w-[90px] mr-[10px]">
										<img src="@/static/image/icon35.png" class="w-[15px] h-[15px] mr-[10px]" />
										<div class="  text-[#A2A2A2]">
											{{langInfo.study_exam_title}}
										</div>
									</div>
									<div class="flex-1  text-[#0F1419]">
										{{langInfo.study_exam_duration}}{{item.courseSubject.exam_duration}}min；{{langInfo.study_exam_total}}{{item.courseSubject.total_score}}；{{langInfo.study_exam_pass}}{{item.courseSubject.qualified_score_line}}
										<!-- <label class="cursor-pointer text-[#2979FF] ml-[20px]"
												@click="examInfoClick(item,index)">{{langInfo.exam_infor_details}}>></label> -->
									</div>
								</div>

								<div class="mb-[10px] flex items-center">
									<el-progress class="flex-1 mr-[10px]" :percentage="Number(item.learning_rate) "
										:stroke-width="8" :showText="false" color="#29bd00" />
									<label class="text-[#29bd00] text-[18px] font-bold">{{item.learning_rate}}%</label>
								</div>

								<div class="flex items-center mb-[8px] text-[12px] text-[#FF0000]">
									{{langInfo.validity_period}}:{{item.expiration_date}}
								</div>
								<div class="text-[#FF0000] text-[12px] mt-[5px]" v-if="item.is_expired==1">
									{{langInfo.study_subject_overdue}}
								</div>
								<div class="flex justify-between items-center">
									<div class="">

									</div>
									<div class="flex items-center">
										<div @click="officialClick(item,index)"
											:class="item.is_expired==1?'bg-[#D1D1D1] text-[#A0A0A0]':'bg-white text-[#101010]  border border-[#bbbbbb] border-solid'"
											class=" mr-[10px] cursor-pointer text-[14px] text-center px-[10px] box-border whitespace-nowrap h-[28px] leading-[28px] rounded-[4px]">
											{{langInfo.study_subject_sample}}
										</div>
										<div @click.stop="addStudyClick(item,index)"
											:class="item.is_expired==1?'bg-[#D1D1D1] text-[#A0A0A0]':'bg-white text-[#101010]  border border-[#bbbbbb] border-solid'"
											class=" mr-[10px] cursor-pointer text-[14px] text-center px-[10px] box-border whitespace-nowrap h-[28px] leading-[28px] rounded-[4px]">
											{{langInfo.study_subject_note}}
											<!-- 学习笔记  3，4 -->
										</div>
										<!-- <div v-if="item.is_subject_list==3" :class="item.isExpired?'bg-[#D1D1D1] text-[#A0A0A0]':'bg-white text-[#101010]  border border-[#bbbbbb] border-solid'"
												class=" mr-[10px] cursor-pointer  text-center px-[10px] box-border whitespace-nowrap h-[28px] leading-[28px] rounded-[4px]">
												学习建议
											</div> -->
										<div v-if="item.is_expired!=1" @click.stop="clearRecord(item,index)"
											class="px-[10px] box-border whitespace-nowrap h-[30px] cursor-pointer no-underline leading-[30px] border border-[#BBBBBB] border-solid rounded-[4px] text-[#101010] text-center text-[14px]">
											{{langInfo.clear_subject_record}}
										</div>

									</div>
								</div>


							</div>
						</div>
						<div class="flex items-center cursor-pointer text-[#FF0000] text-[14px]"
							@click="showClick(item,index)">
							<label v-if="item.isShow" class=" mr-[2px] cursor-pointer"> {{langInfo['Click Collapse']}}
							</label>
							<label v-else-if="!item.isShow" class=" mr-[2px] cursor-pointer">
								{{langInfo['Click to expand']}} </label>
							<img v-if="item.isShow" src="@/static/image/icon32.png"
								class="w-[24px] h-[24px] cursor-pointer" />
							<img v-else-if="!item.isShow" src="@/static/image/icon33.png"
								class="w-[24px] h-[24px] cursor-pointer" />
						</div>


					</div>
					<div class="flex items-center mb-[20px] pb-[6px] bB-03 mt-[20px]" v-if="item.isShow">
						<div @click="navClick(item,index,navitem,navindex)" v-for="(navitem,navindex) in navList"
							:key="navindex"
							:class="[lang=='en'?'mr-[20px]':'mr-[34px]',item.type==navindex?'active text-[#FF0000] font-bold':'text-[#1C1F21]']"
							class="navTitle  2xl:whitespace-nowrap cursor-pointer  relative text-[16px] ">
							{{navitem.title}}
						</div>
					</div>
					<!-- 我的视频课 -->
					<div class="" v-if="item.type==0">
						<el-collapse v-if="item.isShow &&item.isFinish&&item.chapterList.length>0"
							v-model="item.activeName" accordion @change="handleChange(item,index,$event)">
							<div class="" v-if="item.chapterList.length>0">
								<el-collapse-item :name="ind + 1" v-for="(itm,ind) in item.chapterList" :key="ind">

									<template slot="title">
										<div class="flex  items-center justify-between" style="width: 100%;">
											<div class="flex-1">
												{{itm.chapter_name}}
											</div>
											<label v-if="item.activeName==ind + 1"
												class="text-[#878787] text-[14px] mr-[2px] cursor-pointer">{{langInfo['Click Collapse']}}</label>
											<label v-else
												class="text-[#878787] text-[14px] mr-[2px] cursor-pointer">{{langInfo['Click to expand']}}</label>
										</div>
									</template>

									<div class="" v-if="itm.small_list_class.length>0">
										<div v-for="(smallItm,smallIndex) in itm.small_list_class" :key="smallIndex"
											class="py-[20px]  box-border section relative">
											<div class="flex justify-between ">
												<div class="flex-1">
													<div class="flex items-center">
														<img src="@/static/image/icon30.png"
															class="w-[16px] h-[16px]  mr-[6px]" alt="" srcset="" />
														<div class="text-[16px] text-[#101010] ">
															{{smallItm.chapter_name}}
														</div>
													</div>
													<div class="text-[12px] text-[#9399A5] ml-[22px] box-border">
														{{langInfo.study_video_duration}} {{smallItm.allTime}}
													</div>
												</div>
												<div class="flex justify-between">
													<div :class="item.is_expired==1?'bg-[#D1D1D1] text-[#A0A0A0]':'bg-white text-[#101010]  border border-[#BBBBBB] border-solid'"
														@click="seeVideoClick(item,index,itm,ind,smallItm,smallIndex)"
														class="min-w-[80px] h-[30px] px-[10px] cursor-pointer mr-[10px] leading-[30px]    rounded-[4px]  text-center text-[14px]">
														{{langInfo.study_video_submit}}
													</div>
													<div :class="item.is_expired==1?'bg-[#D1D1D1] text-[#A0A0A0]':'bg-white text-[#101010]  border border-[#BBBBBB] border-solid'"
														@click="viewRecord(item,index,itm,ind,smallItm,smallIndex)"
														class="min-w-[80px] h-[30px] px-[10px] cursor-pointer leading-[30px]    rounded-[4px]  text-center">
														{{langInfo.study_course_submit}}
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="text-center py-[20px] box-border"
										v-else-if="itm.small_list_class.length==0">
										{{langInfo.no_chapter_records}}
									</div>
								</el-collapse-item>
							</div>
						</el-collapse>
						<emptyPage v-else-if="item.isShow &&item.isFinish&&item.chapterList.length==0"
							:title="langInfo.no_chapter_records"></emptyPage>
					</div>
					<!-- 我的视频课 -->
					<!-- 真题、模拟考试 -->
					<div class="" v-else-if="item.type==1">
						<div v-if="item.isShow" class="border-02 rounded-[5px] mt-[20px] text-[14px] text-[#101010]">
							<div class="flex items-center bg-[#E2E2E2] ">
								<div @click.shop="selectTestMethod(1,item,index)"
									:class="item.testMethod==1?'bg-white':''"
									class=" h-[36px] px-[30px] box-border cursor-pointer leading-[36px] text-center ">
									{{langInfo.study_exam_system}}
								</div>
								<div @click.shop="selectTestMethod(2,item,index)"
									:class="item.testMethod==2?'bg-white':''"
									class="px-[30px] box-border h-[36px] cursor-pointer leading-[36px] text-center">
									{{langInfo.study_exam_auto}}
								</div>
							</div>
							<div class="py-[16px] px-[23px] box-border">
								<div v-if="item.testMethod==1"
									class="title relative mb-[12px] pl-[20px] box-border text-[16px] text-[#FF0000]  font-bold">

									<div class="mb-[12px]">
										{{langInfo.study_exam_system}}
									</div>
									<div class="text-[12px]  text-[#A3A3A3]">
										{{langInfo.study_exam_system_remark}}
									</div>
								</div>
								<div v-else-if="item.testMethod==2"
									class="title relative flex items-center justify-between mb-[12px]  pl-[20px] box-border text-[16px] text-[#FF0000]  font-bold">
									<div class=" flex-1 mr-[30px]">
										<div class="min-w-[80px] whitespace-nowrap mb-[12px]">
											{{langInfo.study_exam_auto}}
										</div>
										<div class="relative">
											<div :class="item.text_remarks?'':'yw-text-cut-2'"
												class="text-[12px] flex-1 text-[#A3A3A3]   ">
												{{langInfo.study_exam_auto_remark}}
											</div>
											<label @click="showTextClick(item,index)" v-if="!item.text_remarks"
												class="text-[#0080FF] text-[12px] cursor-pointer absolute bottom-[0px] right-[-16px]">{{langInfo['Unfold']}}</label>
											<label @click="showTextClick(item,index)" v-else
												class="text-[#0080FF] text-[12px] cursor-pointer absolute bottom-[0px] right-[-16px]">{{langInfo['Collapse']}}</label>
										</div>

									</div>
									<div @click.stop="autoGenerateClick(item,index)"
										class="min-w-[100px] px-[12px] box-border h-[30px]  leading-[30px] cursor-pointer border border-[#BBBBBB] border-solid rounded-[4px] text-[#101010] text-center text-[14px]">
										{{langInfo.study_exam_auto_submit}}
									</div>
								</div>
								<!-- // type=类型:1=自由组卷,2=模拟考(后台组卷),3章节练习 -->
								<div class="" v-if="item.isFinish&&item.paperList.length>0">
									<div class="mb-[20px]" v-for="(itm,ind) in item.paperList" :key="ind">
										<div
											class=" bg-[#F7F9FC] py-[16px] px-[20px] box-border flex items-center justify-between">
											<div> <label
													v-if="item.testMethod==1">【{{langInfo.study_exam_system}}】</label>
												<label
													v-else-if="item.testMethod==2">【{{langInfo.study_exam_auto}}】</label>
												{{itm.title}}
											</div>
											<!-- -->
											<div class="flex items-center">
												<div v-if="itm.is_question==1" @click="startExam(item,index,itm,ind)"
													class="px-[10px] box-border cursor-pointer whitespace-nowrap h-[30px] no-underline leading-[30px] border border-[#BBBBBB] border-solid rounded-[4px] text-[#101010] text-center text-[14px]">
													{{langInfo.study_exam_start}}
												</div>

												<div v-else-if="itm.is_question==2"
													@click="continueExam(item,index,itm,ind)"
													class="px-[10px] box-border cursor-pointer whitespace-nowrap h-[30px] no-underline leading-[30px] border border-[#BBBBBB] border-solid rounded-[4px] text-[#101010] text-center text-[14px]">
													{{langInfo.study_exam_continue}}
												</div>
												<i @click.stop="showExamClick(itm,ind)"
													:class="itm.isShow?'el-icon-arrow-down':'el-icon-arrow-right'"
													class="cursor-pointer ml-[10px] text-[18px]"></i>
											</div>
										</div>

										<div class="px-[32px] box-border" v-if="itm.isShow&&itm.exam_list.length>0">
											<div v-for="(ts,isIndex) in itm.exam_list" :key="isIndex"
												class=" py-[20px] box-border leading-[20px] bB-01">
												<div class="" v-if="ts.status=='complete'">
													【{{langInfo.study_exam_time}}】:{{ts.start_time}},
													【{{langInfo.study_exam_status}}】:<label
														v-if="ts.status=='pending'">{{langInfo.examing}}</label>
													<label
														v-else-if="ts.status=='tentative'">{{langInfo.pausing}}</label>
													<label
														v-else-if="ts.status=='in_progress'">{{langInfo.examing}}</label>
													<label
														v-else-if="ts.status=='complete'">{{langInfo.study_paper_over}}</label>,
													【{{langInfo.study_exam_system_duration}}】:{{ts.exam_duration}}{{langInfo.study_test_remark1_1}},
													【{{langInfo.study_exam_actual_duration}}】:{{ts.TIME}}{{langInfo.study_test_remark1_1}},
													【{{langInfo.study_exam_wrong_total}}】:{{ts.wrong_count}}/
													{{ts.count}},
													【{{langInfo.study_exam_result_total}}】:{{ts.score}}/
													{{itm.total_score}},
													【{{langInfo.study_exam_result}}】:<label
														v-if="ts.result=='fail'">{{langInfo.not_pass}} </label>
													<label v-else-if="ts.result=='fail'">{{langInfo.passed}} </label>
													<label @click="goExamAnalysis(ts,ind)"
														class="text-[12px] text-[#0080FF] cursor-pointer ml-[16px]">{{langInfo.study_exam_record}}>></label>
												</div>

												<div class="mt-[20px]" v-if="ts.status=='complete'">
													<div
														class="text-center text-[#333333] text-[14px] font-bold mb-[16px]">
														{{langInfo['Analysis of Exam Performance']}}
													</div>
													<div
														class="flex justify-between align-center text-[13px] mb-[14px]">
														<label class="w-[30%]">{{langInfo['study_chapter']}}</label>
														<label
															class="w-[30%] text-center">{{langInfo['questions_number']}}</label>
														<label
															class="w-[30%] text-right">{{langInfo['study_report_percent']}}</label>
													</div>
													<div class="flex justify-between align-center text-[13px] mb-[14px]"
														v-for="(itemResult,indexResult) in ts.result_list"
														:key="indexResult">
														<label class="w-[30%]">{{itemResult.chapter_name}}</label>
														<label class="w-[30%] text-center">{{itemResult.count}}</label>
														<label
															class="w-[30%] text-right">{{itemResult.score_rate}}%</label>
													</div>
												</div>
											</div>
										</div>
										<div v-else-if="itm.isShow&&itm.exam_list.length==0"
											class="pt-[18px] box-border text-center">
											{{langInfo.no_exam_info}}
										</div>
									</div>
								</div>
								<emptyPage v-else-if="item.isFinish&&item.paperList.length==0"
									:title="langInfo.no_test_paper_infor">
								</emptyPage>
							</div>
						</div>
					</div>
					<!-- 真题、模拟考试 -->
					<!-- 章节练习 -->
					<div class="pt-[20px] px-[30px] box-border" v-else-if="item.type==2&&item.isShow">
						<div class="" v-if="item.isFinish&&item.chapterList.length>0">
							<div v-for="(itm,ind) in item.chapterList" :key="ind"
								class="mb-[10px] bg-[#F7F9FC] py-[16px] px-[20px] box-border ">
								<div class="mb-[10px]">{{itm.chapter_name}}</div>
								<div class="">
									<div class=" mb-[10px]" v-if="itm.learning_rate">
										<div class=" flex items-center">
											<el-progress class="flex-1 mr-[10px]"
												:percentage="Number(itm.learning_rate) " :stroke-width="8"
												:showText="false" color="#29bd00" />
											<label
												class="text-[#29bd00] text-[18px] font-bold">{{itm.learning_rate}}%</label>
										</div>
									</div>

									<div class="flex items-center justify-end">
										<label
											class="text-[14px] text-[#2979FF] mr-[14px]">{{langInfo.total_sign}}：{{itm.question_count}}
											{{langInfo.way}}，{{langInfo.study_exercise}} {{itm.done_question_count}}
											{{langInfo.way}}</label>

										<div @click.stop="reciteChapterQuestion(item,index,itm,ind,1)"
											class="px-[10px] box-border whitespace-nowrap h-[30px] mr-[10px] cursor-pointer no-underline leading-[30px] border border-[#BBBBBB] border-solid rounded-[4px] text-[#101010] text-center text-[14px]">
											{{langInfo.study_exercise_read}}
										</div>
										<div @click.stop="startChapterExercise(item,index,itm,ind)"
											class="px-[10px] box-border whitespace-nowrap mr-[10px]  h-[30px] cursor-pointer no-underline leading-[30px] border border-[#BBBBBB] border-solid rounded-[4px] text-[#101010] text-center text-[14px]">
											{{langInfo.study_exercise_start}}
										</div>
										<div @click.stop="clearChapterExercise(item,index,itm,ind)"
											class="px-[10px] box-border whitespace-nowrap  h-[30px] cursor-pointer no-underline leading-[30px] border border-[#BBBBBB] border-solid rounded-[4px] text-[#101010] text-center text-[14px]">
											{{langInfo.Remove}}
										</div>
									</div>
								</div>


							</div>
						</div>
						<emptyPage v-else-if="item.isFinish&&item.chapterList.length==0"
							:title="langInfo.no_chapter_records">
						</emptyPage>
					</div>
					<!-- 章节练习 -->

					<!-- 我的错题 -->
					<div class="pt-[20px] px-[30px] box-border" v-else-if="item.type==3&&item.isShow">
						<div class="" v-if="item.isFinish&&item.chapterList.length>0">
							<div v-for="(itm,ind) in item.chapterList" :key="ind"
								class="mb-[10px] bg-[#F7F9FC] py-[16px] px-[20px] box-border flex items-center justify-between">
								<label class="mr-[10px]">{{itm.chapter_name}}</label>
								<div class="flex items-center">
									<label
										class="text-[14px] text-[#FF0000] mr-[14px] whitespace-nowrap">{{langInfo.study_wrong}}：{{itm.question_userwrong_count}}
										{{langInfo.way}}</label>
									<div @click="errorExamMode(item,index,itm,ind)"
										class="px-[10px] box-border text-[14px] whitespace-nowrap h-[30px] no-underline cursor-pointer mr-[10px] leading-[30px] border border-[#BBBBBB] border-solid rounded-[4px] text-[#101010] text-center ">
										{{langInfo.study_wrong_view}}
									</div>
									<div @click.stop="startErrorExercise(item,index,itm,ind)"
										class="px-[10px] box-border text-[14px] whitespace-nowrap h-[30px] leading-[30px] cursor-pointer border border-[#BBBBBB] border-solid rounded-[4px] text-[#101010] text-center">
										{{langInfo.study_wrong_start}}
									</div>
								</div>
							</div>
						</div>

						<emptyPage v-else-if="item.isFinish&&item.chapterList.length==0"
							:title="langInfo.no_chapter_records">
						</emptyPage>
					</div>
					<!-- 我的错题 -->

					<!-- 我的收藏 -->
					<div class="pt-[20px] px-[30px] box-border" v-else-if="item.type==4&&item.isShow">
						<div class="" v-if="item.isFinish&&item.chapterList.length>0">
							<div v-for="(itm,ind) in item.chapterList" :key="ind"
								class="mb-[10px] bg-[#F7F9FC] py-[16px] px-[20px] box-border flex items-center justify-between">
								<label class="mr-[10px]">{{itm.chapter_name}}</label>
								<div class="flex items-center">
									<label
										class=" text-[#0080FF] mr-[14px] whitespace-nowrap">{{langInfo.study_collect}}：{{itm.user_collection_count}}
										{{langInfo.way}}</label>
									<div @click.stop="reciteChapterQuestion(item,index,itm,ind,2)"
										class="px-[10px] box-border whitespace-nowrap h-[30px] mr-[10px] cursor-pointer  leading-[30px] no-underline border border-[#BBBBBB] border-solid rounded-[4px] text-[#101010] text-center text-[14px]">
										{{langInfo.study_collect_view}}
									</div>
									<div @click.stop="startCollectExercise(item,index,itm,ind)"
										class="px-[10px] box-border whitespace-nowrap h-[30px] leading-[30px] cursor-pointer border border-[#BBBBBB] border-solid rounded-[4px] text-[#101010] text-center text-[14px]">
										{{langInfo.study_collect_start}}
									</div>
								</div>
							</div>
						</div>
						<emptyPage v-else-if="item.isFinish&&item.chapterList.length==0"
							:title="langInfo.no_chapter_records">
						</emptyPage>
					</div>
					<!-- 我的收藏 -->
					<!-- 我的疑问/纠错 -->
					<div class="pt-[20px] px-[30px] box-border" v-else-if="item.type==5&&item.isShow">
						<div class="" v-if="item.isFinish&&item.chapterList.length>0">
							<div v-for="(itm,ind) in item.chapterList" :key="ind"
								class="mb-[10px] bg-[#F7F9FC] py-[16px] px-[20px] box-border flex items-center justify-between">
								<label class="mr-[10px]">{{itm.chapter_name}}</label>
								<div class="flex items-center">
									<label
										class="text-[14px] text-[#FF0000] mr-[14px] whitespace-nowrap">{{langInfo.study_question}}？：{{itm.question_question_count}}
										{{langInfo.way}}</label>
									<div @click.stop="detailsQuestion(item,index,itm,ind)"
										class="px-[10px] box-border whitespace-nowrap h-[30px] no-underline cursor-pointer leading-[30px] border border-[#BBBBBB] border-solid rounded-[4px] text-[#101010] text-center text-[14px]">
										{{langInfo.view_replies}}
									</div>
								</div>
							</div>
						</div>
						<emptyPage v-else-if="item.isFinish&&item.chapterList.length==0"
							:title="langInfo.no_chapter_records">
						</emptyPage>
					</div>
					<!-- 我的疑问/纠错 -->
				</div>
			</div>
			<div class="flex justify-center">
				<el-pagination :page-size="limit" :total="total" :current-page="page" @current-change="currentChange"
					background layout="prev, pager, next">
				</el-pagination>
			</div>
		</div>


		<emptyPage v-else-if="isFinish&&subjectList.length==0" :title="langInfo.no_chapter_records"></emptyPage>

		<!-- 科目介绍 -->
		<el-dialog :title="langInfo.study_subject_title" :visible.sync="subjectVisible" :close-on-click-modal="false"
			width="50%" center>
			<div class="max-h-[50vh] overflow-y-scroll" v-html="subjectBlurb">
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="subjectVisible = false">{{langInfo.cancel}}</el-button>
				<el-button type="primary" @click="subjectVisible = false">{{langInfo.study_paper_confirm}}</el-button>
			</span>
		</el-dialog>
		<!-- 科目介绍 -->

		<!-- 讲师介绍 -->
		<el-dialog :title="langInfo.study_teacher_view" :visible.sync="teacherVisible" :close-on-click-modal="false"
			width="30%" center>
			<div class="" v-html="teacherInfo">

			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="teacherVisible = false">{{langInfo.cancel}}</el-button>
				<el-button type="primary" @click="teacherVisible = false">{{langInfo.study_paper_confirm}}</el-button>
			</span>
		</el-dialog>
		<!-- 讲师介绍 -->
		<!-- 考试信息 -->
		<el-dialog :title="langInfo.exam_infor_details" :visible.sync="examVisible" :close-on-click-modal="false"
			width="30%" center>
			<div class="">
				<div class="mb-[6px]">
					{{langInfo.study_exam_duration}}:{{courseSubject.exam_duration}}min
				</div>
				<div class="mb-[6px]">
					{{langInfo.study_exam_total}}:{{courseSubject.total_score}}
				</div>
				<div class="mb-[6px]">
					{{langInfo.study_exam_pass}}:{{courseSubject.qualified_score_line}}
				</div>
				<div class="mb-[6px]" v-if="courseSubject.count">
					{{langInfo.questions_number}}:{{courseSubject.count}}
				</div>
				<div class="" v-if="courseSubject.score">
					{{langInfo.single_question_score}}:{{courseSubject.score}}
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="examVisible = false">{{langInfo.cancel}}</el-button>
				<el-button type="primary" @click="examVisible = false">{{langInfo.study_paper_confirm}}</el-button>
			</span>
		</el-dialog>
		<!-- 考试信息 -->
		<!-- 视频 -->
		<playVideo :current_video_id="current_video_id" :currentVideo="currentVideo" :allVideoList="videoList"
			:isVideoVisible="videoVisible" :order_item_id="order_item_id" :selectChapterIndex="selectChapterIndex"
			@close="closeVideo" currentValue="getPlayValue">
		</playVideo>
		<!-- 视频 -->

		<!-- 官方样题 -->
		<el-dialog :title="langInfo.study_subject_sample" :visible.sync="officialVisible" :close-on-click-modal="false"
			width="30%" center>
			<div class="" v-html="officialInfo">

			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="officialVisible = false">{{langInfo.cancel}}</el-button>
				<el-button type="primary" @click="officialVisible = false">{{langInfo.study_paper_confirm}}</el-button>
			</span>
		</el-dialog>
		<!-- 官方样题 -->
		<el-dialog :visible.sync="noticeTextShow" :close-on-click-modal="false" width="30%" center>
			<div v-html="noticeText">

			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="closeDialog ">{{langInfo.close_btn}}</el-button>
			</span>
		</el-dialog>

		<!--  -->
	</div>
</template>

<script>
	import emptyPage from '@/components/emptyPage.vue'
	import playVideo from '@/components/playVideo.vue'
	export default {
		name: "videosCourse",
		components: {
			playVideo,
			emptyPage
		},
		data() {
			return {
				lang: '',
				// 科目
				key: '',
				// 科目
				page: 1,
				limit: 6,
				total: 0,
				isFinish: false,
				subjectList: [],
				subjectVisible: false, //科目介绍
				teacherVisible: false, //讲师介绍弹框
				examVisible: false, //考试信息
				courseSubject: {},

				videoVisible: false, //视频显示

				currentVideo: -1, //当前的章节
				order_item_id: -1,
				selectChapterIndex: -1,
				current_video_id: -1,
				videoList: [],
				subjectBlurb: '',
				teacherInfo: "",
				langInfo: {},
				officialVisible: false,
				officialInfo: '',
				chapterList: [],
				type: 0,
				navList: [{
						title: '', //我的视频及课件
					},
					{
						title: '', //我的试卷
					},
					{
						title: '', //我的练习
					},
					{
						title: '', //我的错题
					},
					{
						title: '', //我的收藏
					},
					{
						title: '', //我的疑问/纠错
					}
				],
				isAutoGenerate: true,



				noticeText: '',
				noticeTextShow: false
			}
		},
		mounted() {

			this.getSubject()
			this.lang = localStorage.getItem('lang') || 'zh'
			this.getdict_data()
			// this.getcheckCoursePermission()

		},
		methods: {
			closeDialog() {
				this.noticeTextShow = false;

				localStorage.setItem('isExitNoticeShow', 1)

				localStorage.setItem('lastAdTime', Date.now())


			},

			getcheckCoursePermission() {
				this.$api.checkCoursePermission({}).then((res) => {
					if (res.data.has_permission == 0) {
						const lastTime = Number(localStorage.getItem('lastAdTime'))

						const isExitNoticeShow = localStorage.getItem('isExitNoticeShow')

						const currentTime = Date.now();
						const halfHourInMs = 180000;

						if (isExitNoticeShow != 1) {
							if (lastTime && ((currentTime - lastTime) > halfHourInMs)) {
								this.noticeTextShow = true
							} else if (!lastTime) {
								this.noticeTextShow = true
							}
						}

					}
				}).catch((error) => {})
			},
			setNav() {
				document.title = this.langInfo.pc_name + '-' + this.langInfo.study_center
				this.navList[0].title = this.langInfo.study_my_vedio
				this.navList[1].title = this.langInfo.study_my_exam
				this.navList[2].title = this.langInfo.study_exercise_chapter
				this.navList[3].title = this.langInfo.study_my_wrong
				this.navList[4].title = this.langInfo.study_my_collect
				this.navList[5].title = this.langInfo.study_my_question
			},
			getdict_data() {
				this.$api.dict_data({}).then((res) => {
					console.log(res);
					const obj = {}
					res.data.forEach((item, index) => {
						obj[item.key] = item.value
					})
					this.langInfo = obj;

					this.noticeText = this.langInfo['New user prompt'];

					this.setNav()
					this.$store.dispatch('lang/setLangList', obj)
				}).catch((error) => {})
			},
			change(e) {
				console.log(e);
				this.key = e
				this.page = 1;
				this.total = 0
				this.isFinish = false

				this.getSubject()
			},
			currentChange(e) {
				this.page = e
				this.isFinish = false
				this.getSubject()
			},
			getSubject(item_c, index_c, type_c) {
				let that = this
				// is_subject_list=1题库2视频3课件笔记4全套
				this.$api.getMyPapersWithSubject({
					page: this.page,
					pageSize: this.limit,
					key: this.key,
				}).then((res) => {

					if (item_c) {
						item_c.learning_rate = res.data.data[index_c].learning_rate
					} else {
						res.data.data.forEach((item, index) => {
							this.$set(item, 'isShow', false)
							this.$set(item, 'isFinish', false)
							this.$set(item, 'activeName', 1)
							this.$set(item, 'chapterList', [])

							this.$set(item, 'type', 0)

							this.$set(item, 'testMethod', 1)
							this.$set(item, 'paperList', [])
							this.$set(item, 'text_remarks', false)

						})

						this.subjectList = res.data.data


						this.total = res.data.total
					}

					this.isFinish = true
				}).catch((error) => {
					console.log("error.code====" + error.code);
					this.isFinish = true
					if (error.code == 450) {
						setTimeout(() => {
							const currentUrl = this.$route.fullPath;
							localStorage.setItem('loginRedirect', currentUrl);
							this.$router.replace({ path: '/login' })
						}, 800)
					}
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})

			},
			navClick(item, index, navitem, navindex) {
				this.subjectList.forEach((itm, ind) => {
					if (index == ind) {
						if (itm.isShow) {
							itm.type = navindex
							itm.isFinish = false
							itm.chapterList = []
							if (navindex == 0) {
								this.getVideoList(itm, index)
							} else if (navindex == 1) {
								this.getQuestList(itm, 2, index)
							} else if (navindex == 2) {
								// 章节练习
								this.getChapterList(itm, ind, 2)
							} else if (navindex == 3) {
								// 错题练习
								this.getChapterList(itm, ind, 3)
							} else if (navindex == 4) {
								// 我的收藏
								this.getChapterList(itm, ind, 4)
							} else if (navindex == 5) {
								// 我的疑问/纠错
								this.getChapterList(itm, ind, 5)
							}
						}
					}
				})
			},
			showClick(item, index) {
				if (item.is_expired == 1) {
					this.$message({
						message: this.langInfo.study_subject_overdue,
						type: 'warning'
					})
					return
				}
				this.subjectList.forEach((itm, ind) => {
					if (index == ind) {
						itm.isShow = !itm.isShow
						if (itm.isShow) {
							itm.type = 0
							this.order_item_id = itm.id
							itm.isFinish = false
							this.getVideoList(itm, index)
						}
					} else {
						itm.isShow = false
					}
				})
			},

			showTextClick(item, index) {
				item.text_remarks = !item.text_remarks
			},
			getVideoList(item, index) {
				var that = this
				this.$api.order_chapter_class({
					item_id: item.id,
				}).then((res) => {
					console.log("res.data========");
					console.log(res.data);

					res.data.forEach((item, index) => {
						item.small_list_class.forEach((itm, ind) => {
							let allTime = '00:00'
							if (itm.video_info) {
								allTime = that.convertSecondsToHMS(itm.video_info.file_size)
							}
							that.$set(itm, 'allTime', allTime)
						})
					})
					item.chapterList = res.data
					item.isFinish = true
				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},

			convertSecondsToHMS(seconds) {
				var hours = Math.floor(seconds / 3600);
				var minutes = Math.floor((seconds % 3600) / 60);
				var remainingSeconds = seconds % 60;
				minutes = minutes > 9 ? minutes : '0' + minutes
				remainingSeconds = remainingSeconds > 9 ? remainingSeconds : '0' + remainingSeconds

				var time = "00:00"
				if (hours > 0) {
					hours = hours > 9 ? hours : '0' + hours
					time = hours + ":" + minutes + ":" + remainingSeconds;
				} else {
					time = minutes + ":" + remainingSeconds;
				}

				return time;
			},
			seeVideoClick(item, index, itm, ind, smallItm, smallIndex) {
				if (item.is_expired == 1) {
					this.$message({
						message: this.langInfo.study_subject_overdue,
						type: 'warning'
					})
					return
				}
				if (!item.is_subject_list.includes('2') && !item.is_subject_list.includes('4')) {
					this.$message({
						message: this.langInfo.no_video_permissions,
						type: 'warning'
					})
					return
				}

				this.selectChapterIndex = -1
				this.currentVideo = -1
				this.selectChapterIndex = ind

				this.videoList = itm.small_list_class
				this.currentVideo = smallIndex
				console.log("====smallItm");
				console.log(smallItm);
				this.current_video_id = smallItm.video_info.id
				console.log("==this.current_video_id====" + this.current_video_id);
				this.videoVisible = true

			},
			closeVideo() {
				this.videoVisible = false
			},

			subjectInfoClick(item, index) {
				this.subjectBlurb = item.courseSubject.blurb
				this.subjectVisible = true
			},
			examInfoClick(item, index) {
				this.courseSubject = item.courseSubject
				this.examVisible = true
			},
			teacherInfoClick(item, index) {
				if (!item.teacher_info) {
					// this.$message({
					// 	message: this.langInfo.study_subject_overdue,
					// 	type: 'warning'
					// })
					return

				}
				this.teacherInfo = item.teacher_info.content
				this.teacherVisible = true
			},
			// 官方样题
			officialClick(item, index) {
				if (item.is_expired == 1) {
					this.$message({
						message: this.langInfo.study_subject_overdue,
						type: 'warning'
					})
					return
				}

				this.officialInfo = item.courseSubject.official
				this.officialVisible = true
			},
			// 学习笔记
			addStudyClick(item, index) {

				if (item.is_expired == 1) {
					this.$message({
						message: this.langInfo.study_subject_overdue,
						type: 'warning'
					})
					return
				}

				if (!item.is_subject_list.includes('3') && !item.is_subject_list.includes('4')) {
					this.$message({
						message: this.langInfo.no_relevant_permissions,
						type: 'warning'
					})
					return
				}

				if (item.note_url) {

					const routeData = this.$router.resolve({
						path: '/pdf',
						query: {
							url: encodeURIComponent(routeData.href),
							title: encodeURIComponent(item
								.courseSubject.name)
						}
					})

					window.open(routeData.href, '_blank')

					this.$api.add_lecturer({
						order_item_id: item.id,
						course_resource_id: item.course_resource.id || ''
					}).then((res) => {
						console.log(res);
					}).catch((error) => {
						this.$message({
							message: error.msg,
							type: 'warning'
						})
					})

				} else {
					this.$message({
						message: this.langInfo.no_data_available,
						type: 'warning'
					})
				}
			},
			// 浏览课件
			viewRecord(item, index, itm, ind, smallItm, smallIndex) {

				if (item.is_expired == 1) {
					this.$message({
						message: this.langInfo.study_subject_overdue,
						type: 'warning'
					})
					return
				}

				if (!item.is_subject_list.includes('3') && !item.is_subject_list.includes('4')) {
					this.$message({
						message: this.langInfo.no_relevant_permissions,
						type: 'warning'
					})
					return
				}
				if (smallItm.courseware_info) {
					this.$api.addCoursewareViewRecord({
						order_item_id: item.id,
						course_chapter_small_id: smallItm.id,
						course_resource_id: smallItm.courseware_info.id
					}).then((res) => {
						console.log(res);

						const routeData = this.$router.resolve({
							path: '/pdf',
							query: {
								url: encodeURIComponent(smallItm.courseware_info.url),
								title: encodeURIComponent(smallItm.chapter_name)
							}
						})
						window.open(routeData.href, '_blank')
					}).catch((error) => {
						this.$message({
							message: error.msg,
							type: 'warning'
						})
					})
				} else {
					this.$message({
						message: this.langInfo.no_data_available,
						type: 'warning'
					})
				}
			},
			handleChange(item, index, e) {
				console.log(item.activeName);
				console.log(e);

				item.activeName = e
			},

			selectTestMethod(type, item, index) {
				item.testMethod = type
				item.isFinish = false

				if (type == 1) {
					this.getQuestList(item, 2, index)
				} else if (type == 2) {
					this.getQuestList(item, 1, index)
				}

			},
			getQuestList(item, type, index) {

				// type=类型:1=自由组卷,2=模拟考(后台组卷),3章节练习
				this.$api.question_list({
					type: type,
					course_subject_id: item.course_subject_id,
					order_item_id: item.id
				}).then((res) => {
					console.log(res.data);
					this.subjectList[index].paperList = res.data

					item.isFinish = true

					res.data.forEach((item, index) => {
						this.$set(item, 'isShow', false)
					})

				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			// 开始考试
			startExam(item, index, itm, ind) {

				if (item.is_expired == 1) {
					this.$message({
						message: this.langInfo.study_subject_overdue,
						type: 'warning'
					})
					return
				}
				if (!item.is_subject_list.includes('1') && !item.is_subject_list.includes('4')) {
					this.$message({
						message: this.langInfo.no_relevant_permissions,
						type: 'warning'
					})
					return
				}



				if (itm.exam_list && itm.exam_list.length > 0) {
					this.$confirm(this.langInfo.already_done, this.langInfo.reg_tip, {
						confirmButtonText: this.langInfo.confirm_btn,
						cancelButtonText: this.langInfo.cancel,
						type: 'info'
					}).then((ms) => {
						console.log(ms);
						if (ms == "confirm") {

							let routeData = this.$router.resolve({
								path: '/exam/examTip',
								query: {
									type_part: itm.type_part,
									order_item_id: item.id,
									testMethod: item
										.testMethod,
									id: itm.id
								}
							})

							window.open(routeData.href, '_blank')

						}
					}).catch(() => {

					});
				} else {


					let routeData = this.$router.resolve({
						path: '/exam/examTip',
						query: {
							type_part: itm.type_part,
							order_item_id: item.id,
							testMethod: item.testMethod,
							id: itm.id
						}
					})

					window.open(routeData.href, '_blank')

				}
			},

			// 继续考试
			continueExam(item, index, itm, ind) {
				// type_part=1有部分的题 0是原来的
				if (itm.type_part == 1) {


					let routeData = this.$router.resolve({
						path: '/exam/multipleQuestions',
						query: {
							order_item_id: item.id,
							id: itm.is_exam_list.question_paper_id,
							identification: itm.is_exam_list.identification,
						}
					})

					window.open(routeData.href, '_blank')


				} else {


					let routeData = this.$router.resolve({
						path: '/exam/examQuestions',
						query: {
							order_item_id: item.id,
							id: itm.is_exam_list.question_paper_id,
							identification: itm.is_exam_list.identification,
						}
					})

					window.open(routeData.href, '_blank')


				}

			},
			showExamClick(itm, ind) {
				itm.isShow = !itm.isShow
			},
			// 查看解析
			goExamAnalysis(item, index) {
				console.log(item)
				if (item.is_part == 1) {

					let routeData = this.$router.resolve({
						path: '/exam/multipkeAnalysis',
						query: {
							id: item.question_paper_id,
							identification: item.identification,
							viewMethod: 'read'
						}
					})
					window.open(routeData.href, '_blank')


				} else {

					let routeData = this.$router.resolve({
						path: '/exam/examAnalysis',
						query: {
							id: item.question_paper_id,
							identification: item.identification,
							viewMethod: 'read'
						}
					})
					window.open(routeData.href, '_blank')

				}
			},
			// 点此自动组卷


			autoGenerateClick(item, index) {
				console.log(211212);
				if (item.is_expired == 1) {
					this.$message({
						message: this.langInfo.study_subject_overdue,
						type: 'warning'
					})
					return
				}
				console.log(323);
				if (!item.is_subject_list.includes('1') && !item.is_subject_list.includes('4')) {
					this.$message({
						message: this.langInfo.no_relevant_permissions,
						type: 'warning'
					})
					return
				}


				if (!this.isAutoGenerate) {

					this.$message({
						message: this.langInfo.test_generated,
						type: 'warning'
					})

					return
				}
				this.isAutoGenerate = false

				var that = this



				this.$api.autoGenerate({
					course_subject_id: item.course_subject_id,
					order_item_id: item.id
				}).then((res) => {
					console.log(res.data.code == 1);
					if (res.data.code == 1) {
						item.isFinish = true
						this.getQuestList(item, 1, index)
						this.isAutoGenerate = true
						this.$message({
							message: res.msg,
							type: 'success'
						})
					} else if (res.data.code == 0) {

						this.$confirm(this.langInfo.is_cleared_exercises_record, this.langInfo.reg_tip, {
							confirmButtonText: this.langInfo.clear_tip,
							cancelButtonText: this.langInfo.no_clear,
							type: 'info'
						}).then((ms) => {
							console.log(ms);
							if (ms == "confirm") {
								that.$api.clear_exam_record({
									course_subject_id: item.course_subject_id
								}).then((res) => {
									console.log(res);
									that.reStart(item, index)
								}).catch((error) => {
									that.isAutoGenerate = true
									that.$message({
										message: error.msg,
										type: 'warning'
									})
								})
							}
						}).catch(() => {
							that.randomPaper(item, index)
						});
					}

				}).catch((error) => {
					this.isAutoGenerate = true
					this.$message({
						message: error.msg,
						type: 'warning',
						offset: 240
					})
				})
			},
			// 随机生成
			randomPaper(item, index) {
				var that = this
				this.$api.autoGenerate({
					course_subject_id: item.course_subject_id,
					is_sj: 0,
					order_item_id: item.id
				}).then((res) => {
					item.isFinish = false
					this.isAutoGenerate = true
					this.getQuestList(item, 1, index)
					this.$message({
						message: res.msg,
						type: 'success'
					})
				}).catch((error) => {
					this.isAutoGenerate = true
					this.$message({
						message: error.msg,
						type: 'warning',
						offset: 240
					})
				})
			},
			reStart(item, index) {
				var that = this
				this.$api.autoGenerate({
					course_subject_id: item.course_subject_id,
				}).then((res) => {
					item.isFinish = false
					this.isAutoGenerate = true

					this.getQuestList(item, 1, index)
					this.$message({
						message: res.msg,
						type: 'success'
					})

				}).catch((error) => {
					this.isAutoGenerate = true
					this.$message({
						message: error.msg,
						type: 'warning',
						offset: 240
					})
				})
			},
			getChapterList(item, index, type) {
				this.$api.order_chapter({
					item_id: item.id,
					type: type
				}).then((res) => {
					console.log(res.data);
					this.subjectList[index].chapterList = res.data
					item.isFinish = true
				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			// 清空章节做题记录
			clearRecord(item, index) {

				if (item.is_expired == 1) {
					this.$message({
						message: this.langInfo.study_subject_overdue,
						type: 'warning'
					})
					return
				}
				if (!item.is_subject_list.includes('1') && !item.is_subject_list.includes('4')) {
					this.$message({
						message: this.langInfo.no_relevant_permissions,
						type: 'warning'
					})
					return
				}

				var that = this
				this.$confirm(this.langInfo.clear_record_tip, this.langInfo.reg_tip, {
					confirmButtonText: this.langInfo.study_paper_confirm,
					cancelButtonText: this.langInfo.cancel,
					type: 'warning'
				}).then(() => {
					this.$api.clear_exam_record({
						course_subject_id: item.course_subject_id
					}).then((res) => {
						console.log(res);
						this.$message({
							message: res.msg,
							type: 'success'
						})
						console.log('4344554');
						that.getSubject(item, index, item.type)
						that.getChapterList(item, index, item.type)
					}).catch((error) => {
						this.$message({
							message: error.msg,
							type: 'warning'
						})
					})
				}).catch(() => {

				});
			},
			// 章节练习/收藏练习，背题模式/浏览模式
			reciteChapterQuestion(item, index, itm, ind, mode) {

				if (item.is_expired == 1) {
					this.$message({
						message: this.langInfo.study_subject_overdue,
						type: 'warning'
					})
					return
				}
				if (!item.is_subject_list.includes('1') && !item.is_subject_list.includes('4')) {
					this.$message({
						message: this.langInfo.no_relevant_permissions,
						type: 'warning'
					})
					return
				}
				//mode 1章节练习   2收藏练习  
				if (itm.question_count_zj > 0 && mode == 1) {

					const routeData = this.$router.resolve({
						path: '/exam/reciteQuestionsMode',
						query: {
							orderId: item.id,
							id: itm.id,
							mode: mode
						}
					})
					window.open(routeData.href, '_blank')


				} else if (itm.user_collection_count > 0 && mode == 2) {

					const routeData = this.$router.resolve({
						path: '/exam/reciteQuestionsMode',
						query: {
							orderId: item.id,
							id: itm.id,
							mode: mode
						}
					})
					window.open(routeData.href, '_blank')

				} else {
					this.$message({
						message: this.langInfo.selected_chapter_no_available_tip,
						type: 'warning'
					})
				}
			},
			// 章节练习
			startChapterExercise(item, index, itm, ind) {
				if (item.is_expired == 1) {
					this.$message({
						message: this.langInfo.study_subject_overdue,
						type: 'warning'
					})
					return
				}
				if (!item.is_subject_list.includes('1') && !item.is_subject_list.includes('4')) {
					this.$message({
						message: this.langInfo.no_relevant_permissions,
						type: 'warning'
					})
					return
				}

				if (itm.question_count_zj > 0) {
					//mode 1章节练习   2收藏练习  



					let routeData = this.$router.resolve({
						path: '/exam/chapterExercises',
						query: {
							order_item_id: item.id,
							id: itm.id,
							mode: 1
						}
					})

					window.open(routeData.href, '_blank')

				} else {
					this.$message({
						message: this.langInfo.no_practice_tip,
						type: 'warning'
					})
				}

			},

			// 清空
			clearChapterExercise(item, index, itm, ind) {

				var that = this
				this.$confirm(this.langInfo.clear_record_tip, this.langInfo.reg_tip, {
					confirmButtonText: this.langInfo.study_paper_confirm,
					cancelButtonText: this.langInfo.cancel,
					type: 'warning'
				}).then(() => {
					this.$api.clear_exam_record({
						course_subject_id: item.course_subject_id,
						course_chapter_small_id: itm.id,

					}).then((res) => {
						console.log(res);
						this.$message({
							message: res.msg,
							type: 'success'
						})
						that.getSubject(item, index, item.type)
						that.getChapterList(item, index, item.type)
					}).catch((error) => {
						if (error.msg) {
							this.$message({
								message: error.msg,
								type: 'warning'
							})
						}

					})
				}).catch(() => {

				});


			},
			// 错题练习
			startErrorExercise(item, index, itm, ind) {

				if (item.is_expired == 1) {
					this.$message({
						message: this.langInfo.study_subject_overdue,
						type: 'warning'
					})
					return
				}
				if (!item.is_subject_list.includes('1') && !item.is_subject_list.includes('4')) {
					this.$message({
						message: this.langInfo.no_relevant_permissions,
						type: 'warning'
					})
					return
				}

				// 1章节练习   2收藏练习  3错题练习
				if (itm.question_userwrong_count > 0) {


					let routeData = this.$router.resolve({
						path: '/exam/chapterExercises',
						query: {
							order_item_id: item.id,
							id: itm.id,
							mode: 3
						}
					})

					window.open(routeData.href, '_blank')


				} else {
					this.$message({
						message: this.langInfo.no_practice_questions_available,
						type: 'warning'
					})
				}
			},
			// 错题浏览
			errorExamMode(item, index, itm, ind) {

				console.log(item.is_subject_list);

				if (item.is_expired == 1) {
					this.$message({
						message: this.langInfo.study_subject_overdue,
						type: 'warning'
					})
					return
				}
				if (!item.is_subject_list.includes('1') && !item.is_subject_list.includes('4')) {
					this.$message({
						message: this.langInfo.no_relevant_permissions,
						type: 'warning'
					})
					return
				}
				if (itm.question_userwrong_count > 0) {


					let routeData = this.$router.resolve({
						path: '/exam/errorExamMode',
						query: {
							orderId: item.id,
							id: itm
								.id
						}
					})

					window.open(routeData.href, '_blank')


				} else {
					this.$message({
						message: this.langInfo.selected_chapter_no_available_tip,
						type: 'warning'
					})
				}
			},
			startCollectExercise(item, index, itm, ind) {

				if (item.is_expired == 1) {
					this.$message({
						message: this.langInfo.study_subject_overdue,
						type: 'warning'
					})
					return
				}
				if (!item.is_subject_list.includes('1') && !item.is_subject_list.includes('4')) {
					this.$message({
						message: this.langInfo.no_relevant_permissions,
						type: 'warning'
					})
					return
				}

				// 1章节练习   2收藏练习
				if (itm.user_collection_count > 0) {


					let routeData = this.$router.resolve({
						path: '/exam/chapterExercises',
						query: {
							order_item_id: item.id,
							id: itm.id,
							mode: 2
						}
					})

					window.open(routeData.href, '_blank')


				} else {
					this.$message({
						message: this.langInfo.no_practice_questions_available,
						type: 'warning'
					})
				}
			},
			detailsQuestion(item, index, itm, ind) {
				if (itm.question_question_count > 0) {


					let routeData = this.$router.resolve({
						path: '/exam/detailsQuestion',
						query: {
							order_item_id: item.id,
							id: itm.id,
							type: 'question_sele'
						}
					})

					window.open(routeData.href, '_blank')


				} else {
					this.$message({
						message: this.langInfo.no_reply_questions_tip,
						type: 'warning'
					})
				}
			}

		}
	}
</script>

<style scoped>
	/deep/.el-input__inner::placeholder {
		color: #888888;
	}

	/deep/.el-input__inner {
		height: 100%;
		border-color: #BBBBBB;
	}

	/deep/.el-collapse {
		border: 0px;
		padding: 0 10px;
		box-sizing: border-box;
	}

	/deep/.el-collapse-item__content {
		padding-bottom: 0;
	}

	/deep/.el-collapse-item__header {
		background: #F7F9FC !important;
		height: 64px;
		line-height: 64px;
		color: rgba(0, 0, 0, 1);
		font-size: 16px;
		border: 0px;
		padding: 0 10px;
		box-sizing: border-box;
	}

	/deep/.el-collapse-item__wrap {
		border: 0px;

	}

	.section::after {
		content: '';
		position: absolute;
		width: calc(100% - 22px);
		height: 1px;
		background-color: rgba(216, 216, 216, 0.3);
		bottom: 0;
		right: 0;
	}

	.section:nth-last-child(1)::after {
		content: '';
		position: absolute;
		width: calc(100% - 22px);
		height: 0px;
		background-color: rgba(216, 216, 216, 0.3);
		bottom: 0;
		right: 0;
	}

	.navTitle.active::after {
		content: "";
		position: absolute;
		width: 100%;
		height: 4px;
		background-color: #FF0000;
		bottom: -6px;
		left: 50%;
		transform: translateX(-50%);

	}
</style>